module.exports = __webpack_public_path__ + "static/media/category-5.cf0d8dfa.png";